import React, { useState } from 'react'
import BurgerMenuTitle from '../../../Component/BurgerMenuTitle/BurgerMenuTitle'
import Style from './RequestTaxi.module.css'
import { ArrowDown, GeoAltFill } from 'react-bootstrap-icons'
import { requestTaxiPost } from '../../../Api/TaxiServices'
import { useHistory } from 'react-router-dom'
import { errorToast } from '../../../Toast/Toast'
import { Spinner } from 'react-bootstrap'

const RequestTaxi = (props) => {
  const {current,first,second,response,direct,addressText} = props.location.state
  let history = useHistory()
  const [loadingState,setloadingState]=useState(false)
  const [addressDescriptionState,setAddressDescriptionState]=useState("")
  const requestTaxi=()=>{
    setloadingState(true)
    const info={
      routes:direct,
      routes_description:addressText,
      description:addressDescriptionState
    }
    requestTaxiPost(info,(suc,res)=>{
      if(suc){
        if(res.status===1){
          history.push('/waiting-drivers')
          setloadingState(false)
        }else{
          errorToast(res.message)
          setloadingState(false)
          setTimeout(() => {
            history.push('/taxireqlist')
          }, 500);
        }
      }else{
        console.error(res)
        setloadingState(false)
      }
      
    })
  }
  return (
    <div className={Style.componentHandler}>
      <BurgerMenuTitle title={"تاکسی"}/>
      <section className={Style.center}>
        <div className={Style.addressHolder}>
          <p className={Style.address}><GeoAltFill className={Style.geoIcon}/>{current.address_compact}</p>
        </div>
        <ArrowDown className={Style.arrowIcon}/>
        <div className={Style.addressHolder}>
          <p className={Style.address}><GeoAltFill className={Style.geoIcon}/>{first.address_compact}</p>
        </div>
        {second?
          <>
            <ArrowDown className={Style.arrowIcon}/>
            <div className={Style.addressHolder}>
              <p className={Style.address}><GeoAltFill className={Style.geoIcon}/>{second.address_compact}</p>
            </div>
          </>
        :null}
        <div className={Style.priceHolder}>
          <p className={Style.price}>کرایه: <span style={{color:"#1bc81b"}}>{response.delivery}تومان</span></p>
        </div>
      </section>
      <textarea name="addressDescription" className={Style.AddressDescriptionHolder} placeholder='توضیحات آدرس' onChange={e=>setAddressDescriptionState(e.target.value)}></textarea>
      <button onClick={requestTaxi} className={Style.okBtn} disabled={loadingState}>
        {loadingState?"منتظر باشید...":"درخواست تاکسی"}
      </button>
    </div>
  )
}

export default RequestTaxi